module.exports = __webpack_public_path__ + "img/right_dots_pattern.47644a5a.svg";